module.exports = __webpack_public_path__ + "img/sec_phone1.212a3fa2.png";